import { render, staticRenderFns } from "./MtMaterialsModal.Style#Drawer.vue?vue&type=template&id=3ff48aca&scoped=true&"
import script from "./MtMaterialsModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./MtMaterialsModal.Style#Drawer.vue?vue&type=style&index=0&id=3ff48aca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff48aca",
  null
  
)

export default component.exports